"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionsContainer = exports.OptionWrapper = exports.Icon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../../styles/palette");
var _Icon = _interopRequireDefault(require("../../Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var OptionsContainer = exports.OptionsContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__OptionsContainer",
  componentId: "sc-8lyik3-0"
})(["display:flex;flex-direction:row;gap:16px;margin:0 32px 16px 32px;justify-content:center;"]);
var OptionWrapper = exports.OptionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__OptionWrapper",
  componentId: "sc-8lyik3-1"
})(["transition:all 0.3s;border-radius:5px;width:56px;height:56px;display:flex;align-items:center;justify-content:center;cursor:", ";margin:15px 0;border:2px solid transparent;@media (max-width:1100px){width:40px;height:40px;}", ""], function (p) {
  return p.disabled ? 'default' : 'pointer';
}, function (p) {
  var borderColor = p.value === 0 ? _palette.checklistColors.red : _palette.checklistColors.green;
  var backgroundColor = p.selected ? borderColor : _palette.checklistColors.white;
  return "\n      border-color: ".concat(borderColor, ";\n      background-color: ").concat(backgroundColor, ";\n    ");
});
var Icon = exports.Icon = (0, _styledComponents["default"])(_Icon["default"]).attrs(function (p) {
  return {
    name: p.value === 0 ? 'close' : 'checkmark'
  };
}).withConfig({
  displayName: "styles__Icon",
  componentId: "sc-8lyik3-2"
})(["height:", ";color:", ";"], function (p) {
  return p.value === 0 ? '15px' : '25px';
}, function (_ref) {
  var selected = _ref.selected,
    value = _ref.value;
  return selected ? _palette.checklistColors.white : value === 0 ? _palette.checklistColors.red : _palette.checklistColors.green;
});
//# sourceMappingURL=styles.js.map